import { defineEffect } from '../../../core/effect';

/**
 * **ダメージステップの開始**（Issue #538）。
 *
 * 開く: `damage_step_start`。短い横一閃だけ（**ここで何が起きるかはまだ分からない**ので、
 * 区切りが付いたことだけを見せる）。ダメージ計算そのものは `battle`。
 */
export default defineEffect({
  situation: 'damage_step_start',
  label: 'ダメージステップ',
  color: '#ff9a5a',

  layers: [
    {
      id: 'slash',
      label: '一閃',
      part: 'beam',
      at: { screen: [960, 540] },
      props: { color: '#ff9a5a', core: 0.06 },
      tf: {
        scale: { keys: [{ ms: 0, value: 0.1 }, { ms: 180, value: 1, ease: 'ease_out' }, { ms: 420, value: 1 }] },
        opacity: { keys: [{ ms: 0, value: 0 }, { ms: 140, value: 0.85 }, { ms: 420, value: 0 }] },
      },
    },
  ],
}, 'damage_step_start_effect.js');
